import { Box, Stack, IconButton, Grid, Input, Typography, Button, Paper, experimentalStyled as styled, Hidden } from "@mui/material";
import { FC, useEffect, useState, useRef, useImperativeHandle } from "react";
import React from "react";
import { 
  stagingManager,
  stageControl,
  EBiteJumpLocationType,
 } from "@/gluelayer"

import TriangleIcon from "./triangleIcon";
import StageAddIcon from "./stageAddIcon";
import { visibility } from "html2canvas/dist/types/css/property-descriptors/visibility";
import ReactDOM from 'react-dom';
import StageItem from "./stageItem";
import StageFoldItem from "./stageFoldItem";
import StageGmButton from "./stageGmButton";
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { UButton } from "@/components/index"
import { isNodeContains } from "./stageCommon";
import StageItemNone from "./stageItemNone";
import StageIndexItemSimple from "./stageIndexItemSimple";

const ButtonItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const StageIndexSimple = (props) => {

  const [stageList, setStageList] = useState([]);
  const stepRef = useRef({})
  const singleStageWidth = 23
  const StageDiv = 4
  const singleStageHeight = 22

  useImperativeHandle(props.onRef, () => ({
    getStagePositionX,
    getStageStepByPositionX,
    setCurrentStep,
    // calcMaxArchWidth,
  }))

  const callBackStepRef = (e: HTMLElement, stepIndex: number) => {
    stepRef.current["step_" + stepIndex] = e
  }

  const setCurrentStep = (step: number) => {
    // setStageCurrentStep(step)

  }

  const stageButtonClickHandle = (item, index, itemArray) => {
    props.stepChangeHandler(props.archType, index)
  }

  const getStagePositionX = (stepIndex: number) => {
    //var rect = element.getBoundingClientRect();
    //return { x: rect.left, y: rect.top };
    const e = stepRef.current["step_" + stepIndex]
    if (e === undefined || e === null) {
      return 0
    }
    const rect = e.getBoundingClientRect()
    const middleX = rect.left + (rect.width / 2.0)

    const parentE = e.offsetParent
    let parentELeft = 0
    if (parentE !== undefined && parentE !== null) {
      const parentRect = parentE.getBoundingClientRect()
      parentELeft = parentRect.left
    }

    //console.info("=====getStagePositionX: ", middleX);
    return middleX - parentELeft
  }

  const getStageStepByPositionX = (positionX: number) => {
    for (let i = 0; i < props.nodes.length; i++) {
      const xMiddle = getStagePositionX(i)
      if (
        xMiddle - (singleStageWidth + StageDiv) / 2 <= positionX &&
        positionX <= xMiddle + (singleStageWidth + StageDiv) / 2
      ) {
        return i
      }
    }
    return -1
  }

  const addNodeHandler = () => {
    
  }

  const judgeWhichItem = (item, index, itemArray) => {
    return (
      <StageIndexItemSimple
        archType={props.archType}
        index={index}
        stageCurrentStep={props.currentStep}
        stageAnotherStep={props.anotherStep}
        isNodeContains={isNodeContains}
        item={item}
        itemArray={itemArray}
        stageMinCount={props.stageMinCount}
        addNodeHandler={addNodeHandler}
        stageButtonClickHandle={stageButtonClickHandle}
        stageDiv={StageDiv}
        singleStageWidth={singleStageWidth}
        singleStageHeight={singleStageHeight}
        countOfFoldGroup={props.countOfFoldGroup}
        actualStageWidth={props.actualSingleStageWidth}
        uiShowType={props.uiShowType}
        viewEdit={props.viewEdit}
        upQuick3Index={props.upQuick3Index}
        downQuick3Index={props.downQuick3Index}
      />
    )
  }

  const loadStageUi = () => {
    if(stageList.length > 0)
    {
      return stageList.map((item, index, itemArray) => {
        return (
          <Stack
            ref={(e: HTMLElement) => {
              callBackStepRef(e, index)
            }}
            direction="row"
            spacing={0}
            key={item.indexStr}
          >
            {judgeWhichItem(item, index, itemArray)}
          </Stack>
        )
      })
    }
    else if(props.refineNumber >= 0) {
      const item = {
        indexStr: props.refineNumber === 0 ? "0" : "R"+props.refineNumber,
        nodeTypes: [],
      }
      var itemArray = []
      itemArray.push(item)
      return (
        <Stack
          direction="row"
          spacing={0}
          key={"zero_item"}
        >
          <StageIndexItemSimple
            archType={props.archType}
            index={0}
            stageCurrentStep={-1}
            stageAnotherStep={-1}
            isNodeContains={isNodeContains}
            item={item}
            itemArray={itemArray}
            stageMinCount={props.stageMinCount}
            addNodeHandler={()=>{}}
            stageButtonClickHandle={()=>{}}
            stageDiv={StageDiv}
            singleStageWidth={singleStageWidth}
            singleStageHeight={singleStageHeight}
            countOfFoldGroup={props.countOfFoldGroup}
            actualStageWidth={props.actualSingleStageWidth}
            uiShowType={props.uiShowType}
            viewEdit={props.viewEdit}
            upQuick3Index={props.upQuick3Index}
            downQuick3Index={props.downQuick3Index}
          />
        </Stack>
      )
    }
  }

  const loadStageData = () => {
    console.info(
      "loadStageData=====nodes count",
      props.nodes.length,
      props.archName,
    )
    var newStageList = []
    for (var i = 0; i < props.nodes.length; i++) {
      //console.info("=====", props.nodes[i].stepindex, props.nodes[i].name, props.nodes[i].nodeType);
      newStageList.push({
        indexStr: props.nodes[i].name,
        nodeTypes: props.nodes[i].nodeType,
      })
    }

    console.info("=====set stageList", props.archName, newStageList.length)
    setStageList(newStageList)

    console.info("=====stageCurrentStep: ", props.archName, props.currentStep)
    // setIsCurrentStepChangedByClick(false)
  }

  useEffect(() => {
    // calcStageWidth()
  }, [props.countOfFoldGroup])

  useEffect(() => {
    loadStageData()
  },
    []
  );

  useEffect(() => {
    loadStageData()
  },
    [props.nodes]
  );

  useEffect(() => {
    // 这里的代码会在每次渲染后执行
    // console.info("stage arch:" + props.archType + "render finished: " + stageList.length)
    props.loadFinished(props.archType)
  });

  return (
    <Box>
      <Stack direction="row" spacing={0}>   

        <Box sx={{width: 3 + ((singleStageWidth - props.actualSingleStageWidth) / 2), height: 1}}></Box>
        {loadStageUi()}
        <Box sx={{width: 3 + ((singleStageWidth - props.actualSingleStageWidth) / 2), height: 1}}></Box>
        
      </Stack>
    </Box>
  );
}

export default StageIndexSimple;